import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { PrintIcon } from "../../../icons";
import { useRootStore } from "../../../store/contexts";

type PrintFormProps = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
};

export const PrintFormButton: React.FC<PrintFormProps> = observer(
  ({ onClick, disabled, label }) => {
    const rootStore = useRootStore();
    const { prefStore, langStore } = rootStore;

    return (
      <Button
        variant={"action"}
        size={prefStore.toolbarSize}
        startIcon={<PrintIcon />}
        disabled={disabled === undefined ? false : disabled}
        onClick={onClick}
      >
        {!label ? langStore.printForm : label}
      </Button>
    );
  }
);
